// Technologies whose provider side is reached at a URL the user has to supply —
// Gundi cannot pull from an EarthRanger site it doesn't have the address of. Other
// provider types have a fixed endpoint baked into the connector.
//
// Shared by the creation wizard (which has to ask for it) and the flow map (which
// has to let the user change it), so the two can't disagree about who needs one.
export const PROVIDER_TYPES_WITH_BASE_URL = ["earth_ranger", "cellstop", "mella_tracking"];

export const providerNeedsBaseUrl = (typeValue?: string): boolean =>
    !!typeValue && PROVIDER_TYPES_WITH_BASE_URL.includes(typeValue);
